import * as React from 'react'
import * as PropTypes from 'prop-types'
import styled from 'styled-components'
import { Slide } from 'react-reveal'

import AccessibleForm from '../../../../components/accessibility/AccessibleForm/AccessibleForm'
import Icon from '../../../../components/ui/Icon/Icon'
import ActionButton from '../../../../components/ui/ActionButton/ActionButton'
import OtpForm from '../../../../components/home/OtpForm/OtpForm'
import OtpResendForm from '../../../../components/home/OtpResendForm/OtpResendForm'
import NominatePasswordForm from '../../../../components/home/NominatePasswordForm/NominatePasswordForm'

import truncateString from '../../../../services/data/truncateString'

import { deleteAccessToken } from '../../../../services/data/accessToken'

import MoreHeaderParticles from '../../../../assets/img/more-header-particles.svg'

import validateOtp from '../../../../services/validation/OTP'
import validatePasswordNomination from '../../../../services/validation/PasswordNomination'

import * as ProfileApiService from '../../../../services/api/requests/Profile'
import * as RegisterApiService from '../../../../services/api/requests/Register'

import { SETTINGS } from '../../../../services/data/profilePages.json'
import { deleteUuid } from '../../../../services/data/webUuid'

const MainPage = styled.div`
  display: ${props => (props.show ? 'flex' : 'none')};
  flex-direction: column;
  overflow: hidden;
  height: 100%;
`

const Header = styled.div`
  position: relative;
  display: flex;
  flex: 0 0 auto;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  min-height: 87px;
  font-size: 0.7rem;
  background: var(--color-primary);

  &::before {
    content: ' ';
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    background: url('${MoreHeaderParticles}');
    background-repeat: no-repeat;
    background-position: right top;
  }
`

const ReturnIcon = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 2rem;
  height: 2rem;
  border-radius: 2rem;
  cursor: pointer;
  font-size: 0.92rem;
  margin-left: 20px !important;
  margin-right: 20px !important;
  color: var(--color-fg-light);
  background: rgba(255, 255, 255, 0.5);
  z-index: 1;

  & > svg {
    position: relative;
    color: #ffffff;
  }
`

const Title = styled.h1`
  flex: 1;
  padding: 20px 0;
  margin: 0;
  margin-right: 60px;
  color: #ffffff;
  font-size: 1.125rem;
  font-weight: var(--font-weight-boldest);
  text-transform: uppercase;
  text-align: center;
`

const Content = styled.div`
  padding: 2rem 1.1875rem;
  overflow: auto;
`

const DetailPageContainer = styled.div`
  display: ${props => (props.show ? 'block' : 'none')};
  background-color: inherit;
  transition-property: width;
  transition-duration: var(--animation-duration);
  transition-timing-function: var(--animation-linear);
  overflow: hidden;
  height: 100vh;
`

const DetailPageContent = styled.div`
  flex: 1 1 auto;
  padding: 2rem;
`

const SubTitle = styled.h5`
  font-size: 1rem;
  margin: 0;
  margin-bottom: 0.2rem;
`

const SubTitleCenter = styled(SubTitle)`
  text-align: center;
`

const Description = styled.p`
  text-align: center;
`

const FormWrapper = styled.div`
  margin-bottom: 2rem;
`

const PermissionLabel = styled.div`
  text-align: center;
  font-size: 0.875rem;
  margin: 1rem 0;
`

const SuccessMessageWrapper = styled.div`
  padding: 4rem 0;
  text-align: center;
`

const SuccessMessageTitle = styled.h2`
  font-size: 1.5rem;
  margin: 0;
  margin-bottom: 1rem;
  font-weight: bold;
`

const SuccessMessage = styled.p`
  margin: 0;
  margin-bottom: 1rem;
`

const StyledActionButton = styled(ActionButton)`
  margin-top: 3rem;
`

class ChangePasswordPage extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      showChangePassword: false,
      changePasswordSuccess: false,
      updatePasswordToken: '',
      errorMessage: '',
    }

    this.form = React.createRef()
  }

  componentDidMount() {
    this.requestOtp()
  }

  componentDidUpdate(prevProps, prevState) {
    const { showChangePassword } = this.state
    const { showChangePassword: prevShowChangePassword } = prevState

    if (
      this.form &&
      showChangePassword &&
      prevShowChangePassword !== showChangePassword
    ) {
      this.form.current.getFormikActions().validateForm()
    }
  }

  showDetailPage = data => {
    this.setState({
      selectedMessage: data,
    })
  }

  closeDetailPage = () => {
    this.setState({
      selectedMessage: null,
    })
  }

  submit = async (values, state) => {
    const { accessToken, setAccessToken, setPrimaryInfo } = this.props
    const { updatePasswordToken } = this.state
    const { password } = values

    state.setSubmitting(true)

    // REMOVED - updatePassword function no longer exists
    try {
      // const validateResponse = await ProfileApiService.updatePassword(
      //   password,
      //   updatePasswordToken,
      //   accessToken,
      // )

      // const { accessToken: newAccessToken, user } = validateResponse.data

      // setAccessToken(newAccessToken)
      // setPrimaryInfo(user)

      // this.setState({
      //   changePasswordSuccess: true,
      // })
      throw new Error('updatePassword function no longer exists')
    } catch (error) {
      const { data = {}, status } = error.response || {}
      const { message = 'Network Error' } = data || {}

      state.setStatus({
        status,
        error: message,
      })
    }
    state.setSubmitting(false)
  }

  verify = async (values, state) => {
    const { accessToken } = this.props
    const { updatePasswordToken } = this.state
    const { code } = values

    state.setSubmitting(true)

    // REMOVED - validatePasswordOtp function no longer exists
    try {
      // const validateResponse = await ProfileApiService.validatePasswordOtp(
      //   code,
      //   updatePasswordToken,
      //   accessToken,
      // )

      // const { updatePasswordToken: responseToken } = validateResponse.data

      // this.setState({
      //   showChangePassword: !!responseToken,
      //   updatePasswordToken: responseToken,
      // })
      throw new Error('validatePasswordOtp function no longer exists')
    } catch (error) {
      const { data = {} } = error.response || {}
      const { message = 'Network Error' } = data || {}

      state.setStatus({
        error: 'There was an error processing your request',
      })

      if (message.toLowerCase().indexOf('otp') >= 0) {
        state.setFieldError('code', 'Invalid OTP')
        state.setStatus({})
      }
    }
    state.setSubmitting(false)
  }

  requestOtp = async () => {
    const { accessToken } = this.props

    // REMOVED - changePasswordOtp function no longer exists
    try {
      // const requestOtpResponse = await ProfileApiService.changePasswordOtp(
      //   accessToken,
      // )

      // this.setState({
      //   updatePasswordToken: requestOtpResponse.data.updatePasswordToken,
      // })
      throw new Error('changePasswordOtp function no longer exists')
    } catch (e) {
      this.setState({
        errorMessage: 'Unable to request OTP Verification',
      })
    }
  }

  resend = async (values, state) => {
    state.setSubmitting(true)
    const { updatePasswordToken } = this.state

    try {
      await ProfileApiService.changePasswordOtpResend(updatePasswordToken)
    } catch (error) {
      const { data = {}, status } = error.response || {}
      const { message = 'Network Error' } = data || {}

      state.setStatus({
        status,
        error: message,
      })
    }
    state.setSubmitting(false)
  }

  validatePasswordNomination = async data => {
    const validation = validatePasswordNomination(data)

    // REMOVED - postPasswordStrength function no longer exists
    // if (!validation.password_not_common && data.password) {
    //   try {
    //     const passwordRespose = await RegisterApiService.postPasswordStrength(
    //       data.password,
    //     )
    //     const { level, message } = passwordRespose.data

    //     if (level === 'weak') {
    //       validation.password_not_common = message
    //     }
    //   } catch (error) {
    //     if (error.message !== 'Network Error') {
    //       const { data: errorData } = error.response

    //       validation.password_not_common = errorData.message
    //     }
    //   }
    // }

    throw validation
  }

  doLogout = () => {
    const {
      setAccountStatus,
      setAccessToken,
      setPrimaryInfo,
      push,
    } = this.props
    deleteAccessToken()
    deleteUuid()
    setPrimaryInfo(null)
    setAccessToken(null)
    setAccountStatus(null)
    push('/login')
  }

  render() {
    const { showChangePassword, changePasswordSuccess } = this.state
    const { setProfileModalPage, primaryInfo } = this.props
    const { mobileNumber = '', firstName } = primaryInfo || {}

    const DetailPage = ({ show }) => {
      return (
        <DetailPageContainer show={show}>
          {!!show && (
            <Slide right duration={200}>
              <Header>
                <ReturnIcon onClick={() => setProfileModalPage(SETTINGS)}>
                  <Icon name="slide-left" />
                </ReturnIcon>
                <Title>Change Password</Title>
              </Header>
              <DetailPageContent>
                {!changePasswordSuccess ? (
                  <AccessibleForm
                    ref={this.form}
                    initialValues={{}}
                    validate={this.validatePasswordNomination}
                    onSubmit={this.submit}
                    component={NominatePasswordForm}
                    componentProps={{
                      newPassword: true,
                    }}
                    action="/a/register/password"
                  />
                ) : (
                  <SuccessMessageWrapper>
                    <SuccessMessageTitle>
                      Hello, {truncateString(firstName, 20)}!
                    </SuccessMessageTitle>
                    <SuccessMessage>
                      Your password has been updated.
                    </SuccessMessage>
                    <SuccessMessage>
                      Secure your account by logging in again.
                    </SuccessMessage>
                    <StyledActionButton
                      variant="primary"
                      onClick={() => this.doLogout()}
                    >
                      Continue
                    </StyledActionButton>
                  </SuccessMessageWrapper>
                )}
              </DetailPageContent>
            </Slide>
          )}
        </DetailPageContainer>
      )
    }

    return (
      <>
        <MainPage show={!showChangePassword}>
          <Header>
            <ReturnIcon onClick={() => setProfileModalPage(SETTINGS)}>
              <Icon name="slide-left" />
            </ReturnIcon>
            <Title>Change Password</Title>
          </Header>
          <Content>
            <SubTitleCenter>Verify mobile number</SubTitleCenter>
            <Description>
              You will receive a One-Time PIN (OTP) on your registered mobile
              number ending in <span>{mobileNumber.slice(-4)}</span>.
            </Description>
            <FormWrapper>
              <AccessibleForm
                initialValues={{}}
                validate={validateOtp}
                onSubmit={this.verify}
                component={OtpForm}
                action="/a/otp/submit"
                method="post"
              />
            </FormWrapper>
            <PermissionLabel>
              Did not receive code?{' '}
              <AccessibleForm
                initialValues={{}}
                onSubmit={this.resend}
                component={OtpResendForm}
                action="/a/otp/resend"
                method="post"
              />
            </PermissionLabel>
          </Content>
        </MainPage>
        <DetailPage show={showChangePassword} />
      </>
    )
  }
}

ChangePasswordPage.defaultProps = {
  primaryInfo: {},
}

ChangePasswordPage.propTypes = {
  primaryInfo: PropTypes.object,
}

export default ChangePasswordPage
